import { createFileRoute } from '@tanstack/react-router';

import { ScreenStub } from '@/components/layout/ScreenStub';

export const Route = createFileRoute('/leagues/$leagueId/trades')({
  component: Screen,
});

function Screen() {
  return (
    <ScreenStub
      title="Trades"
      capability="leagues.view"
      planned="Pending proposals with both sides' assets, votes and expiry, plus trade history. Force-push and rescind map to existing endpoints; reversing a completed trade needs a new one built next to the logic it must not diverge from."
    />
  );
}
